export interface Project {
  id: string;
  name: string;
  abbreviation: string;
  assignedClientId: string;
  comment: string;
  isActiveForDPR: boolean;
  projectSettingId?: number;
}
